<template>
  <v-card elevation="7"
    class="mt-6"
    min-height="500"
  >
    <v-row class="ml-12 mt-n6">
      <v-col class="mb-3">
        <v-card-subtitle class="ml-2">
          <h2 class="text-uppercase">
            {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{roleUser}}
            <span v-if="currentUser.presidente == 1"> presidente</span>
          </h4>
          <v-divider class="mt-3"/>
        </v-card-subtitle>

        <v-btn
          v-if="roleUser=='magistrado'"
          small
          class="white--text ml-2 mt-1 mr-4"
          style="float: right;"
          color="#1D2E4B"
          @click="$router.push({ name:'PendientesFirma' })"
        >
          Pendientes de Firma
        </v-btn>

        <v-btn
          v-if="roleUser == 'magistrado'"
          small
          class="white--text ml-2 mt-1"
          style="float: right"
          color="blue-grey"
          @click="$router.push({ name:'Asignacion' })"
        >
          Ver mi Turno
        </v-btn>
      </v-col>
    </v-row>
    <span @click="focusOnElement()">
      <v-navigation-drawer
        style="z-index: 2;"
        permanent
        expand-on-hover
        absolute
        color="#1D2E4B"
        dark
        width="280Px"
      >
        <v-list-item>
          <v-list-item-avatar class="ml-n2 mt-6">
            <!-- <v-img src="https://randomuser.me/api/portraits/men/5.jpg"></v-img> -->
          </v-list-item-avatar>
          <v-list-item-title class="text-uppercase">
            {{roleUser}}<br>
            {{ currentUser.nombre }} <br>
            {{ currentUser.primer_apellido }}  {{ currentUser.segundo_apellido }}
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list
          class="mt-5"
          nav
          dense
        >
          <v-list-item-group
            @change="buscar = '', anio='', numero = '', current = 1, getCuentas()"
            v-model="active_tab"
            color="primary"
            active-class="white--text text--accent-1"
          >
            <v-list-item
              v-for="(item, i) in items_status"
              :value="item"
              return-object
              :key="item.title"
              :disabled="ocultar_menu"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
                <v-badge dot color="yellow" v-if="total_asignados > 0 && item.value == 40"></v-badge>
                <v-badge dot color="yellow" v-if="total_para_cuenta > 0 && item.value == 41"></v-badge>
                <v-badge dot color="yellow" v-if="total_para_sesion > 0 && item.value == 42"></v-badge>
                <v-badge dot color="yellow" v-if="total_colegiada > 0 && item.value == 43"></v-badge>
                <v-badge dot color="yellow" v-if="total_para_firma > 0 && item.value == 44"></v-badge>
              </v-list-item-icon>
              <v-list-item-content style="padding: 1px 0;">
                <v-list-item-title class="text-uppercase">
                  <span>{{item.title}}</span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                  <span class="font-weight-bold" v-if="total_asignados > 0 && item.value == 40">
                  {{total_asignados}} </span>
                  <span class="font-weight-bold" v-if="total_para_cuenta > 0 && item.value == 41">
                  {{total_para_cuenta}} </span>
                  <span class="font-weight-bold" v-if="total_para_sesion > 0 && item.value == 42">
                  {{total_para_sesion}} </span>
                  <span class="font-weight-bold" v-if="total_colegiada > 0 && item.value == 43">
                  {{total_colegiada}} </span>
                  <span class="font-weight-bold" v-if="total_para_firma > 0 && item.value == 44">
                  {{total_para_firma}} </span>
                  <span class="font-weight-bold" v-if="total_concluidos > 0 && item.value == 45">
                  {{total_concluidos}} </span>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </span>
    <v-row class="ml-12" v-if="active_tab && active_tab.value == 44">
      <v-col class="mb-3">
        <v-card-subtitle class="ml-2">
          <v-icon
            class="mt-n1"
            x-large
            color="#607D8B"
          >
            mdi-account-group-outline
          </v-icon>
          <span class="text-h6 font-weight-bold ml-2 text-uppercase" style="color:#1D2E4B">
            Tocas Pendientes de Firma
          </span>
          <v-row class="mt-2" v-if="roleUser=='magistrado'">
            <v-col
              v-for="(ponencia, key) in getAllPonencias"
              :key="key"
              cols="12"
              sm="4"
              @click="buscarPorPonencia(ponencia)"
            >
              <v-card
                v-if="poneciaSelected"
                class="pa-2 font-weight-bold"
                dark
                hover
                outlined
                elevation=5
                color="blue-grey darken-2"
                align="center"
              >
                {{ ponencia.magistrado }}
              </v-card>
            </v-col>
          </v-row>
          <v-card-subtitle v-if="poneciaSelected && roleUser=='magistrado'" class="mt-2 mb-n8" align="center">
            <h1>{{ poneciaSelected.magistrado }}</h1>
          </v-card-subtitle>
        </v-card-subtitle>
      </v-col>
    </v-row>

    <v-data-table
      :header-props="headerProps"
      :headers="headers"
      :items="getAllCuentas"
      item-key="id"
      class="elevation-1 ml-14"
      :loading="loading"
      loading-text="Cargando... Espere un momento"
      no-data-text="No hay Tocas por mostrar"
      :page="current"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <v-row>
          <v-col cols="6">
            <v-toolbar-title class="text-uppercase ml-7 mt-5"
              v-if="active_tab && active_tab.value != 44"
            ><b style="color:#1D2E4B">{{ active_tab.title }}</b>
            </v-toolbar-title>
          </v-col>
          <v-col :cols="active_tab && (roleUser=='magistrado' && active_tab.value == 45 ? 3 : 6)">
            <v-text-field
              class="mr-1"
              placeholder="Buscar Toca"
              v-model="buscar"
              hint="Ej. 1/2023"
              :loading="loading"
              clearable
              clear-icon="mdi-close"
              @click:clear="clearSearch"
              v-on:keyup.enter="searchToca"
            >
              <v-btn slot="prepend" outlined fab x-small color="#607D8B" @click='searchToca()'>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-text-field>
            </v-col>
            <v-col cols="3" v-if="active_tab && active_tab.value == 45 && roleUser=='magistrado'">
            <v-select
              class="mr-2"
              @change="buscar = '', anio='', numero = '', current = 1, getCuentas()"
              label="Filtrar por Ponencia"
              :item-text=" item => item.magistrado"
              item-value="user_id"
              persistent-hint
              :items = "getAllPonencias"
              v-model="concluidas_magistrado_id"
              clearable
            ></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.toca="{ item }">
        {{ item.toca.numero }}/{{ item.toca.anio }}<span v-if="item.toca.complemento">
          -{{ item.toca.complemento }}</span>
      </template>
      <template v-slot:item.apelacion.fecha_turno="{ item }">
        {{ item.apelacion.fecha_turno | formatDate }}
      </template>
      <template v-slot:item.fecha_cuenta="{ item }">
        {{ item.fecha_cuenta | formatDate }}
      </template>
      <template v-slot:item.fecha_sentencia="{ item }">
        {{ item.fecha_sentencia | formatDate }}
      </template>
      <template v-slot:item.fecha_baja="{ item }">
        {{ item.fecha_baja | formatDate }}
      </template>
      <template v-slot:item.tiempo.fecha_vencimiento="{ item }">
        <v-card v-if="item.tiempo.dias_dif <= 1" width="150" class="white--text text--accent-1" style="background-color: #ef0404">
          <span class="ml-3"><b>{{ item.tiempo.fecha_vencimiento | formatDate }}</b></span>
        </v-card>
        <v-card v-if="item.tiempo.dias_dif == 2" width="150" class="white--text text--accent-1" style="background-color: #e79f00">
          <span class="ml-3"><b>{{ item.tiempo.fecha_vencimiento | formatDate }}</b></span>
        </v-card>
        <v-card v-if="item.tiempo.dias_dif > 2" width="150" class="white--text text--accent-1" style="background-color: #08af19">
          <span class="ml-3"><b>{{ item.tiempo.fecha_vencimiento | formatDate }}</b></span>
        </v-card>
      </template>
      <!-- LAS PONENCIAS TIENEN SORT POR NOMBRE: 0->ponencia A, 1->Ponencia B, 2->Ponencia C -->
      <template v-slot:header.firma_a="{ item }">
        {{ sortPonencias[0].magistrado }}
      </template>
      <template v-slot:header.firma_b="{ item }">
        {{ sortPonencias[1].magistrado }}
      </template>
      <template v-slot:header.firma_c="{ item }">
        {{ sortPonencias[2].magistrado }}
      </template>
      <template v-slot:header.nombre_ponencia="{ item }">
        {{ roleUser == 'magistrado' ? 'Ponencia' : 'Relator' }}
      </template>
      <template v-slot:item.nombre_ponencia="{ item }">
        {{ roleUser == 'magistrado' ? item.nombre_magistrado : item.nombre_relator }}
      </template>
      <template v-slot:item.firma_a="{ item }">
        <div v-if="item.resolucion_firmas.length==0">
          <h4 class="red--text">SIN RESOLUCIÓN</h4>
        </div>
        <div v-for="firma in item.resolucion_firmas">
          <div v-if="firma && sortPonencias[0].user_id == firma.magistrado_id && firma.firmado==1">
            <v-icon class="mr-2" color="green">
              mdi-check-bold
            </v-icon>
          </div>
          <div v-if="firma && sortPonencias[0].user_id == firma.magistrado_id && firma.firmado==0">
            <v-icon class="mr-2" color="grey">
              mdi-minus
            </v-icon>
          </div>
        </div>
      </template>
      <template v-slot:item.firma_b="{ item }">
        <div v-if="item.resolucion_firmas.length==0">
          <h4 class="red--text">SIN RESOLUCIÓN</h4>
        </div>
        <div v-for="firma in item.resolucion_firmas">
          <div v-if="firma && sortPonencias[1].user_id == firma.magistrado_id && firma.firmado==1">
            <v-icon class="mr-2" color="green">
              mdi-check-bold
            </v-icon>
          </div>
          <div v-if="firma && sortPonencias[1].user_id == firma.magistrado_id && firma.firmado==0">
            <v-icon class="mr-2" color="grey">
              mdi-minus
            </v-icon>
          </div>
        </div>
      </template>
      <template v-slot:item.firma_c="{ item }">
        <div v-if="item.resolucion_firmas.length==0">
          <h4 class="red--text">SIN RESOLUCIÓN</h4>
        </div>
        <div v-for="firma in item.resolucion_firmas">
          <div v-if="firma && sortPonencias[2].user_id == firma.magistrado_id && firma.firmado==1">
            <v-icon class="mr-2" color="green">
              mdi-check-bold
            </v-icon>
          </div>
          <div v-if="firma && sortPonencias[2].user_id == firma.magistrado_id && firma.firmado==0">
            <v-icon class="mr-2" color="grey">
              mdi-minus
            </v-icon>
          </div>
        </div>
      </template>
      <template v-slot:item.status="{ item }">
        <span v-if="item.status == 40">
          EN SESION
        </span>
        <span v-else-if="item.status == 41">
          PARA CUENTA
        </span>
        <span v-else-if="item.status == 42">
          PARA SESIONAR
        </span>
        <span v-else-if="item.status == 43">
          COLEGIADA
        </span>
        <span v-else-if="item.status == 44">
          PARA FIRMA
        </span>
        <span v-else-if="item.status == 45">
          CONCLUIDA
        </span>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-btn color="#1D2E4B" outlined text small @click="showCuenta(item)">VER
        </v-btn>
      </template>
    </v-data-table>
    <div v-if="total>=2" class="text-center pt-2 pb-1">
      <v-pagination
        :disabled="loading"
        class="mt-3"
        v-model="current"
        :length="total"
        @input="getCuentas"
        :total-visible='7'
      >
      </v-pagination>
    </div>

  </v-card>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from 'vuex'
  import _ from 'lodash';

  export default {
    metaInfo: {
      title: 'Bandeja de Cuentas'
    },
    data() {
      return {
        headerProps: {
          sortByText: "Ordenar por..."
        },
        pageCount: 0,
        current:1,
        itemsPerPage: 20,
        total:0,
        page: 1,
        per_page_table: 20,
        mandatoryTab: true,
        headers: [],
        active_tab: {},
        loading: true,
        buscar: '',
        sala_id: '',
        ponencia_id: '',
        dialog: false,
        anio:'',
        numero:'',
        total_asignados:0,
        total_para_cuenta:0,
        total_para_sesion:0,
        total_colegiada:0,
        total_para_firma:0,
        total_concluidos:0,
        getAllCuentas:[],
        items_status: [
          { title: 'Asignadas', value:40, icon: 'mdi-account-arrow-right' },
          { title: 'Para cuenta', value:41, icon: 'mdi-account-details' },
          { title: 'Enviar a Firmas', value:42, icon: 'mdi-account-supervisor' },
          { title: 'Pendiente de firma', value:44, icon: 'mdi-signature-freehand' },
          { title: 'Concluidas', value:45, icon: 'mdi-file-check-outline' },
        ],
        ocultar_menu: false,
        concluidas_magistrado_id:''
      }
    },
    computed: {
      ...mapGetters(["listSalas", "roleUser", "currentUser", "getAllPonencias", "poneciaSelected", "navigationData"]),
      sortPonencias: function () {
        return _.orderBy(this.getAllPonencias, 'nombre', 'asc')
      }
    },
    created() {
      if (localStorage.getItem("currentApelacion")) {
        localStorage.removeItem("currentApelacion");
      }
      if(this.getAllPonencias.length==0){
        this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" }).then(response =>{
          this.$store.dispatch("SELECT_PONENCIA", this.currentUser.ponencia);
        });
      }
      if (this.roleUser == 'superadmin') {
        this.loading = false
        return false;
      } else {
        let user = JSON.parse(localStorage.getItem('user'));
        this.sala_id = user.sala_id
        this.ponencia_id = user.ponencia_id
      }
    },
    mounted(){
      if (this.navigationData) {
        this.active_tab = this.navigationData
      } else {
        this.mandatoryTab = false
        this.active_tab = { title: 'Asignadas', value:40, icon: 'mdi-account-plus' }
      }
      this.getCuentas();
    },
    methods: {
      getCuentas(){
        this.ocultar_menu = true
        if (this.active_tab == undefined) {
          this.active_tab = this.navigationData
        }
        if (this.active_tab.title == 'Resultados de busqueda') {
          this.anio = this.active_tab.anio
          this.numero = this.active_tab.numero
          this.complemento = this.active_tab.complemento
          if (this.complemento) {
            this.buscar = this.active_tab.numero + '/' + this.active_tab.anio + '-' + this.active_tab.complemento
          } else {
            this.buscar = this.active_tab.numero + '/' + this.active_tab.anio
          }
        }
        // GUARDAMOS DATOS DE NAVEGACION
        this.$store.commit("SAVE_NAVIGATION", this.active_tab);
        // END
        if (this.active_tab.value == 44) {
          this.magistrado_id_firmante = this.poneciaSelected.user_id
        } else if (this.active_tab.value == 45) {
          this.magistrado_id_firmante = this.concluidas_magistrado_id
        } else {
          this.magistrado_id_firmante = null
        }
        this.loading = true
        this.getAllCuentas = []
        this.headers_apelaciones = []
        this.$store.dispatch("GET_CUENTAS", {
          url: "cuentas",
          params: {
            page: this.current,
            status: this.active_tab.value,
            colegiadas: this.colegiadas || undefined,
            anio: this.anio || undefined,
            numero: this.numero || undefined,
            complemento: this.complemento || undefined,
            magistrado_id_firmante: this.magistrado_id_firmante
          }
        }).then(response => {
          this.loading = false
          this.current = response.data.data.cuentas.current_page;
          this.total = response.data.data.cuentas.last_page;
          this.getAllCuentas = response.data.data.cuentas.data;
          this.total_asignados = response.data.data.totalAsignadas
          this.total_para_cuenta = response.data.data.totalParaCuenta
          this.total_para_sesion = response.data.data.totalParaSesion
          this.total_colegiada = response.data.data.totalColegiada
          this.total_para_firma = response.data.data.totalFirma
          this.total_concluidos = response.data.data.totalConcluidas
          this.getHeaders()
          this.ocultar_menu = false
        });
      },
      getHeaders(){
        if (this.active_tab.value == 40 || this.active_tab.value == 41) {
          this.headers = [
            { text: 'Toca', align: 'start', value: 'toca' },
            { text: 'Expediente', value: 'toca.expediente' },
            { text: 'Relator', value: 'nombre_relator' },
            { text: "Tipo Apelacion", value: "apelacion.tipo_apelacion.nombre" },
            { text: 'Fecha Turno', value: 'apelacion.fecha_turno' },
            { text: 'Acciones', value: 'acciones', sortable: false },
          ]
        }
        if (this.active_tab.value == 42 || this.active_tab.value == 43) {
          this.headers = [
            { text: 'Toca', align: 'start', value: 'toca' },
            { text: 'Expediente', value: 'toca.expediente' },
            { text: 'Relator', value: 'nombre_relator' },
            { text: "Tipo Apelacion", value: "apelacion.tipo_apelacion.nombre" },
            { text: 'Fecha Turno', value: 'apelacion.fecha_turno' },
            { text: 'Fecha Cuenta', value: 'fecha_cuenta' },
            { text: 'Acciones', value: 'acciones', sortable: false },
          ]
        }
        if(this.active_tab.value==44) {
          this.headers = [
            { text: 'Toca', align: 'start', value: 'toca' },
            { text: 'Relator', value: 'nombre_relator' },
            { text: "Tipo Apelacion", value: "apelacion.tipo_apelacion.nombre" },
            { text: 'Fecha de Cuenta', value: 'fecha_cuenta' },
            { text: 'Sentido Final', value: 'sentido_colegiada.nombre' },
            { text: 'Firma', value: 'firma_a', sortable: false, align:"left" },
            { text: 'Firma', value: 'firma_b', sortable: false, align:"left" },
            { text: 'Firma', value: 'firma_c', sortable: false, align:"left" },
            { text: 'Acciones', value: 'acciones', sortable: false },
          ]
        }
        if(this.active_tab.value==45) {
          this.headers = [
            { text: 'Toca', align: 'start', value: 'toca' },
            { text: 'Expediente', value: 'toca.expediente' },
            { text: 'Ponencia', value: 'nombre_ponencia' },
            { text: "Tipo Apelacion", value: "apelacion.tipo_apelacion.nombre" },
            { text: 'Fecha de Resolución', value: 'fecha_sentencia' },
            { text: 'Fecha Baja', value: 'fecha_baja' },
            { text: 'Sentido Final', value: 'sentido_colegiada.nombre' },
            { text: 'Acciones', value: 'acciones', sortable: false },
          ]
        }
        if(!this.active_tab.value) {
          this.headers = [
            { text: "Estatus", value: "status", align: "", sortable: true, width: '' },
            { text: 'Toca', align: 'start', value: 'toca' },
            { text: 'Expediente', value: 'toca.expediente' },
            { text: 'Relator', value: 'nombre_relator' },
            { text: "Tipo Apelacion", value: "apelacion.tipo_apelacion.nombre", align: "", sortable: true, width: '' },
            { text: 'Fecha Turno', value: 'apelacion.fecha_turno' },
            // { text: 'Vence', value: 'fecha_vencimiento' },
            // { text: 'Tiempo', value: 'dias' },
            { text: 'Acciones', value: 'acciones', sortable: false },
          ]
        }
      },
      showCuenta(item){
        localStorage.setItem("currentCuenta", item.id)
        this.$router.push('/apelacion-detalles' )
      },
      onPageChange() {
        this.getCuentas()
      },
      searchToca(){
        if (!this.buscar) return false;
        if (this.buscar.length >= 5 ) {
          this.status = { text: "", value: "" };
          // if ( this.buscar.includes("/") ) var tocacompleto = this.buscar.replace('/','');
          // else var tocacompleto = this.buscar;
          // this.complemento = tocacompleto.split('-').splice(1).join('-');
          // this.anio = tocacompleto.substr(tocacompleto.length - 4);
          // this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          var toca_registrar = this.buscar.split('-')[0];
          var tocacompleto = toca_registrar.replace('/','');
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          this.complemento = this.buscar.split('-').splice(1).join('-');
          this.mandatoryTab = false
          this.active_tab = {
            title: 'Resultados de busqueda',
            anio: this.anio,
            numero: this.numero,
            complemento: this.complemento
          }
          this.getCuentas()
        }
      },
      clearSearch () {
        this.mandatoryTab = true
        this.numero = ''
        this.anio = ''
        this.active_tab =  { title: 'Asignadas', value:40, icon: 'mdi-account-plus' }
        this.getCuentas()
      },
      buscarPorPonencia(ponencia){
        this.$store.dispatch("SELECT_PONENCIA", ponencia);
        this.getCuentas()
      },
      focusOnElement(){
        setTimeout(function () {
          var element = document.getElementById("inspire");
          window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth'});
        }.bind(this), 200);
      }
    }
  }
</script>
<style type="text/css">
.theme--dark.v-list {
    color: white !important;
}
</style>